var map = {
	"./modules/adjudicacio-places/adjudicacio-places.module": [
		"./src/app/modules/adjudicacio-places/adjudicacio-places.module.ts",
		"modules-adjudicacio-places-adjudicacio-places-module"
	],
	"./modules/administracio/administracio.module": [
		"./src/app/modules/administracio/administracio.module.ts",
		"common",
		"modules-administracio-administracio-module"
	],
	"./modules/alta/alta.module": [
		"./src/app/modules/alta/alta.module.ts",
		"default~modules-alta-alta-module~modules-dades-personals-dades-personals-module",
		"common"
	],
	"./modules/assessorament/assessorament.module": [
		"./src/app/modules/assessorament/assessorament.module.ts",
		"default~modules-assessorament-assessorament-module~modules-certificats-certificats-module~modules-da~d94a3610",
		"common",
		"modules-assessorament-assessorament-module"
	],
	"./modules/canvi-semestre/canvi-semestre.module": [
		"./src/app/modules/canvi-semestre/canvi-semestre.module.ts",
		"modules-canvi-semestre-canvi-semestre-module"
	],
	"./modules/certificats/certificats.module": [
		"./src/app/modules/certificats/certificats.module.ts",
		"default~modules-assessorament-assessorament-module~modules-certificats-certificats-module~modules-da~d94a3610",
		"common",
		"modules-certificats-certificats-module"
	],
	"./modules/dades-personals/dades-personals.module": [
		"./src/app/modules/dades-personals/dades-personals.module.ts",
		"default~modules-assessorament-assessorament-module~modules-certificats-certificats-module~modules-da~d94a3610",
		"default~modules-alta-alta-module~modules-dades-personals-dades-personals-module",
		"common",
		"modules-dades-personals-dades-personals-module"
	],
	"./modules/documentacio/documentacio.module": [
		"./src/app/modules/documentacio/documentacio.module.ts",
		"default~modules-assessorament-assessorament-module~modules-certificats-certificats-module~modules-da~d94a3610",
		"common",
		"modules-documentacio-documentacio-module"
	],
	"./modules/expedient/expedient.module": [
		"./src/app/modules/expedient/expedient.module.ts",
		"default~modules-assessorament-assessorament-module~modules-certificats-certificats-module~modules-da~d94a3610",
		"common",
		"modules-expedient-expedient-module"
	],
	"./modules/filtres-alumnes/filtres-alumnes.module": [
		"./src/app/modules/filtres-alumnes/filtres-alumnes.module.ts",
		"modules-filtres-alumnes-filtres-alumnes-module"
	],
	"./modules/filtres-fills/filtres-fills.module": [
		"./src/app/modules/filtres-fills/filtres-fills.module.ts",
		"modules-filtres-fills-filtres-fills-module"
	],
	"./modules/gestio-cicles/gestio-cicles.module": [
		"./src/app/modules/gestio-cicles/gestio-cicles.module.ts",
		"modules-gestio-cicles-gestio-cicles-module"
	],
	"./modules/gestio-grups/gestio-grups.module": [
		"./src/app/modules/gestio-grups/gestio-grups.module.ts",
		"modules-gestio-grups-gestio-grups-module"
	],
	"./modules/gestio-materies/gestio-materies.module": [
		"./src/app/modules/gestio-materies/gestio-materies.module.ts",
		"modules-gestio-materies-gestio-materies-module"
	],
	"./modules/gestio-tramits-alumne/gestio-tramits-alumne.module": [
		"./src/app/modules/gestio-tramits-alumne/gestio-tramits-alumne.module.ts",
		"default~modules-assessorament-assessorament-module~modules-certificats-certificats-module~modules-da~d94a3610",
		"default~modules-gestio-tramits-alumne-gestio-tramits-alumne-module~modules-gestio-tramits-gestio-tra~3592e8ba",
		"common",
		"modules-gestio-tramits-alumne-gestio-tramits-alumne-module"
	],
	"./modules/gestio-tramits/gestio-tramits.module": [
		"./src/app/modules/gestio-tramits/gestio-tramits.module.ts",
		"default~modules-assessorament-assessorament-module~modules-certificats-certificats-module~modules-da~d94a3610",
		"default~modules-gestio-tramits-alumne-gestio-tramits-alumne-module~modules-gestio-tramits-gestio-tra~3592e8ba",
		"common",
		"modules-gestio-tramits-gestio-tramits-module"
	],
	"./modules/itinerari/itinerari.module": [
		"./src/app/modules/itinerari/itinerari.module.ts",
		"default~modules-assessorament-assessorament-module~modules-certificats-certificats-module~modules-da~d94a3610",
		"common",
		"modules-itinerari-itinerari-module"
	],
	"./modules/login-as/login-as.module": [
		"./src/app/modules/login-as/login-as.module.ts",
		"modules-login-as-login-as-module"
	],
	"./modules/mitjana-alumnes/mitjana-alumnes.module": [
		"./src/app/modules/mitjana-alumnes/mitjana-alumnes.module.ts",
		"default~modules-mitjana-alumnes-mitjana-alumnes-module~modules-qualificacio-proves-qualificacio-prov~b0842f66",
		"common",
		"modules-mitjana-alumnes-mitjana-alumnes-module"
	],
	"./modules/pafs-alumne/pafs-alumne.module": [
		"./src/app/modules/pafs-alumne/pafs-alumne.module.ts",
		"default~modules-assessorament-assessorament-module~modules-certificats-certificats-module~modules-da~d94a3610",
		"common",
		"modules-pafs-alumne-pafs-alumne-module"
	],
	"./modules/pafs-gestio/pafs-gestio.module": [
		"./src/app/modules/pafs-gestio/pafs-gestio.module.ts",
		"modules-pafs-gestio-pafs-gestio-module"
	],
	"./modules/pagament/pagament.module": [
		"./src/app/modules/pagament/pagament.module.ts",
		"default~modules-assessorament-assessorament-module~modules-certificats-certificats-module~modules-da~d94a3610",
		"common",
		"modules-pagament-pagament-module"
	],
	"./modules/qualificacio-proves/qualificacio-proves.module": [
		"./src/app/modules/qualificacio-proves/qualificacio-proves.module.ts",
		"default~modules-mitjana-alumnes-mitjana-alumnes-module~modules-qualificacio-proves-qualificacio-prov~b0842f66",
		"common",
		"modules-qualificacio-proves-qualificacio-proves-module"
	],
	"./modules/rols/rols.module": [
		"./src/app/modules/rols/rols.module.ts",
		"modules-rols-rols-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;